import {useContext} from "react"
import axios from "axios"
import GlobalContext from "../contexts/GlobalContext"
import useLoader from "../hooks/useLoader"

export default function useApi(){

    const [globalContext] = useContext(GlobalContext)
    const {manageLoader} = useLoader()

    return async (endpoint, data, localFileName, responseType) => {

        let url = globalContext.base_url + "api/" + endpoint

        manageLoader("show")

        if (data.not_loader === true) {
            manageLoader("hide")
        }

        let postData = {
            ...data,
            session_token: globalContext.session_token
        }

        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: url,
                data: postData,
                responseType: "blob",
            }).then((response) => {
                if (globalContext.dev_mode) {
                    console.log(endpoint)
                    console.log(postData)
                    console.log(response.data)
                    console.log("-------------------------")
                }
                manageLoader("hide")

                const blob = new Blob([response.data], { type: responseType });
                const downloadUrl = window.URL.createObjectURL(blob);

                const contentDisposition = response.headers?.["content-disposition"] || response.headers?.["Content-Disposition"]
                let headerFileName = ""
                if (contentDisposition) {
                    const match = /filename\*?=(?:UTF-8''|\")?([^";]+)/i.exec(contentDisposition)
                    if (match && match[1]) {
                        try {
                            headerFileName = decodeURIComponent(match[1])
                        } catch (error) {
                            headerFileName = match[1]
                        }
                    }
                }
                const resolvedFileName = localFileName || headerFileName || "download"

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', resolvedFileName);
                document.body.appendChild(link);
                link.click();
                link.remove();

                resolve(response.data)
            }).catch((error) => {
                manageLoader("hide")
                reject(error)
            })
        })
    }
}
